export default {"src":"/_next/static/media/Hypertension.b0596175.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};